/**
 * GIO TRUOT — phan JS (ban DA CHOT v36 "gio bam Gymshark").
 *
 * KHUNG giu nguyen cua Bamboove: `<theme-drawer id="cart-drawer">` + `<dialog>` +
 * `<cart-drawer-component auto-open>` => hieu ung mo/dong, khoa tieu diem, phim Escape,
 * `on:click="#cart-drawer/open|close"` va `Shopify.actions.openCart` deu chay nhu cu.
 *
 * RUOT GIO do Liquid ve (`snippets/cart-drawer.liquid`) => MOI con so (so doi, tien giam
 * 10/25/30 %, tam tinh, tong, thanh free ship) dung 1 nguon: may chu Shopify.
 * JS KHONG tu tinh tien => khong the lech voi nhan tren trang.
 *
 * JS chi lam 4 viec:
 *   1) nut so luong (− / +) va nut "Remove"  => /cart/change.js (kem `sections`)
 *   2) nut "Undo"                            => /cart/add.js (them lai dung variant)
 *   3) ve lai ruot gio bang HTML may chu tra ve + cap nhat so tren nut gio o header
 *   4) GOI Y THEM trong gio ("You might also like") => /recommendations/products.json
 *      (08/10/2026 · phien 46: hoc tu gio GYMSHARK — ho co carousel goi y trong gio:
 *       API `minicart/recommendations/popularity` + `.../promotions`, lop `minicart-recommendations-skeleton`)
 *
 * Gan su kien o `document` (UY QUYEN SU KIEN) => khong bi mat khi Bamboove ve lai section.
 */

const SECTION = 'cart-drawer-section';
const SO_DE_XOA = 0;
const API = { change: '/cart/change.js', add: '/cart/add.js' };

/** Cac ten su kien "gio vua doi" co the gap (Bamboove dung @shopify/events) */
const SU_KIEN_GIO = ['shopify:cart:lines-update', 'cart:lines-update', 'cart:update'];

/** Mon vua xoa — giu lai 1 ban de co the "Undo" (bam them mon moi thi quen) */
let vuaXoa = null;
/** (17/10/2026) 4 giây tính từ lần ĐẦU HIỆN — KHÔNG reset mỗi lần giỏ vẽ lại
 *  (P79 MutationObserver gọi hienDaiUndo liên tục ⇒ nếu reset thì toast không bao giờ tắt). */
let daHenUndo = false;
let lucHienUndo = 0;
/** (76e) Cờ "GÁC việc mở giỏ": thêm hàng khi giỏ TRỐNG ⇒ đợi hàng về mới mở (học Horizon). */
let choMoSau = false;
/** (76f) GỘP LỆNH SỐ LƯỢNG: bấm +/− liên tục ⇒ chỉ gửi 1 request sau 350ms (y Horizon debounce 300ms). */
const henSoLuong = new Map(); /* line → timeout id */
/** (76f) CHỐNG LỆNH VỀ NGƯỢC THỨ TỰ: chỉ áp dụng phản hồi của lệnh MỚI NHẤT đã gửi. */
let seqGoi = 0;
let seqGoiAp = 0;
/** (76f) Đang chạy 1 lệnh đổi giỏ? (khoá mềm — y Horizon `cart-items-disabled`). */
let dangChayLenh = false;

/** @returns {HTMLElement | null} ruot gio hien tai */
const layRuot = () => document.querySelector('#cart-drawer .bb-gio');

/** @returns {HTMLElement | null} vung cuon chung (thanh ship + thanh goi + ds mon + goi y) */
const layCuon = () => document.querySelector('#cart-drawer [data-bb-cuon]');

/** Bat/tat lop cho khi dang doi gio (y Gymshark: loading-overlay + spinner) */
function datDangBan(bat) {
  const gio = layRuot();
  if (!gio) return;
  gio.classList.toggle('is-dang-ban', Boolean(bat));
  gio.setAttribute('aria-busy', bat ? 'true' : 'false');
}

/** (76c) THU GỌN 1 DÒNG MÓN khi bấm Remove — học Horizon `onLineItemRemove`
 *  (animate chiều cao rồi mới bỏ). Nhờ vậy cú bấm thấy “mất NGAY” (0ms) dù máy chủ
 *  còn ~600ms mới trả lời; lỗi mạng ⇒ HTML mới không về, dòng cũ ở lại (đã thu gọn). */
function dongMon(monEl) {
  if (!monEl || monEl.classList.contains('bb-gio__mon--xoa')) return;
  monEl.style.height = monEl.getBoundingClientRect().height + 'px';
  monEl.classList.add('bb-gio__mon--chuan-bi-xoa');
  requestAnimationFrame(() => monEl.classList.add('bb-gio__mon--xoa'));
}

/** (76e) SHIMMER nhẹ ~0.9s trên 1 CON SỐ — học Horizon (`textComponent.shimmer()` +
 *  `cartTotal?.shimmer()`): dải sáng chạy qua chữ thay cho vòng xoay “đang load”. */
function nhaySo(el) {
  if (!el) return;
  el.classList.remove('bb-shimmer');
  void el.offsetWidth; /* ép vẽ lại ⇒ bấm liên tiếp vẫn chạy lại hoạt ảnh */
  el.classList.add('bb-shimmer');
  window.setTimeout(() => el.classList.remove('bb-shimmer'), 950);
}

/** Cuon thi do bong dau gio / chan gio (y Gymshark: header + cart-actions--scrolling) */
function capNhatBongCuon() {
  const cuon = layCuon();
  cuon?.closest('.bb-gio')?.classList.toggle('is-cuon', cuon.scrollTop > 4);
}

/** Chep chu — uu tien API moi, khong co (trang http / trinh duyet cu) thi dung textarea */
function chepChu(chu) {
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(chu);
  return new Promise((xong) => {
    const o = document.createElement('textarea');
    o.value = chu;
    o.setAttribute('readonly', '');
    o.style.position = 'fixed';
    o.style.opacity = '0';
    document.body.appendChild(o);
    o.select();
    document.execCommand('copy');
    o.remove();
    xong();
  });
}

/** Goi AJAX Cart API + ve lai ruot gio bang HTML may chu tra ve
 *  P65-CART-FIX (13/10/2026): goi /cart/change.js ROI goi /recommendations/products.json
 *  ===> 2 fetch noi tiep (200-400ms). Doi:
 *  1) Chay `taiGoiY()` SONG SONG voi capNhatSoGio() (Promise.all) => tiet kiem 200-400ms.
 *  2) Set `lanThayRuot` NGAY khi bat dau goi de event listener KHONG goi `veLaiRuotGio()` thua
 *     (truoc day doi 1.2s, nhung nhu vay co the van goi lai fetch 1 lan nua).
 *  3) Su kien `cart:lines-update` phat ra SAU khi fetch xong, nhung DOM da duoc cap nhat
 *     => `veLaiRuotGio()` chi can GOI khi `Date.now() - lanThayRuot > 2500`.
 *
 *  P65-CART-FIX-V2 (13/10/2026): Do thuc te /cart/change.js voi `sections: SECTION` tra ve
 *  29.9 KB HTML (full section), mat 600-650ms. KHONG gui `sections` chi mat 565ms nhung
 *  response chi 1.2 KB. Doi: 2 mode:
 *    - `goi()`: (76c · 17/10/2026) QUAY LAI gửi `sections` — máy chủ trả LUÔN HTML ruột giỏ
 *      trong 1 lượt (đo lại: gộp 1 request nhanh hơn chuỗi 2 request ~250ms; y Horizon).
 *      Đường dự phòng vẫn giữ: phản hồi không có HTML ⇒ tự gọi SRA như cũ.
 *    - `goiCoSection()`: van gui sections (cho Add-to-cart can render day du ngay).
 */
async function goi(duong, than) {
  // Giu cho cuon: ruot gio duoc ve lai => khong nho thi khach dang xem mon cuoi bi nhay len dau.
  const viTriCuon = layCuon()?.scrollTop ?? 0;
  /* (76f) ĐÁNH SỐ THỨ TỰ LỆNH trước khi gửi — phản hồi của lệnh CŨ về sau lệnh MỚI sẽ bị BỎ
     (tránh giỏ “quay lui” khi khách bấm nhanh nhiều lệnh). */
  const seq = ++seqGoi;
  dangChayLenh = true; /* (76f) khoá mềm để các đường khác (thẻ bên ngoài) không nhận thêm lệnh */
  datDangBan(true); // hien lop cho => khach biet dang chay, khoi bam lien tuc
  // P65-CART-FIX: set NGAY de event listener khong goi veLaiRuotGio() trong 2.5s toi
  lanThayRuot = Date.now();
  try {
    /* (76c) 1 REQUEST thay vì 2 (học Horizon: họ cũng gửi `sections` trong lượt đổi giỏ):
       baseline 03:25 = change.js 563ms + SRA riêng 297ms TUẦN TỰ ≈ 875ms; gộp còn ~600ms. */
    const tra = await fetch(duong, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...than, sections: SECTION }),
    }).then((r) => r.json());

    daTaiGoiY = null; // ruot gio vua thay => phai lay goi y moi
    if (seq < seqGoiAp) {
      /* (76f) lệnh CŨ về muộn (đã có lệnh mới hơn áp dụng) ⇒ BỎ — không ghi đè, không cập nhật số cũ */
      return;
    }
    seqGoiAp = seq;
    const htmlMoi = tra?.sections?.[SECTION];
    const renderPromise = htmlMoi
      ? Promise.resolve(lamMoi(htmlMoi))       /* co san HTML => thay NGAY, khoi request phu */
      : veLaiRuotGio().catch(loi => {          /* may chu khong tra sections => duong cu */
          console.warn('[gio] khong render lai ruot gio:', loi);
        });
    /* (76c) KHONG cho taiGoiY() nua: khoi goi y nam DUOI vung nhin — cho no chi lam
       vong xoay quay lau hon (lamMoi / veLaiRuotGio da tu goi taiGoiY o che do nen). */
    await Promise.all([
      renderPromise,
      Promise.resolve(capNhatSoGio(tra)),
    ]);

    hienDaiUndo();

    const cuonMoi = layCuon();
    if (cuonMoi) cuonMoi.scrollTop = viTriCuon;
    capNhatBongCuon();
  } catch (loi) {
    console.warn('[gio] khong doi duoc gio:', loi);
  } finally {
    datDangBan(false);
    dangChayLenh = false; /* (76f) nhả khoá mềm */
  }
}

/** Mode cu: van gui sections, dung khi can render drawer day du ngay (Add-to-cart).
 *  P65-CART-FIX-V2: giu lai de tuong thich nguoi goi, nhung Add-to-cart cua Bamboove
 *  cung dung `goi()` (xem product-form.js), nen ham nay hien khong con duoc goi.
 *  Van de lai de phong nguoi dung sua code sau. */
async function goiCoSection(duong, than) {
  const viTriCuon = layCuon()?.scrollTop ?? 0;
  datDangBan(true);
  lanThayRuot = Date.now();
  try {
    const tra = await fetch(duong, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...than, sections: SECTION }),
    }).then((r) => r.json());
    thayRuot(tra?.sections?.[SECTION]);
    daTaiGoiY = null;
    Promise.all([
      Promise.resolve(capNhatSoGio(tra)),
      taiGoiY(),
    ]).catch(loi => console.warn('[gio] song song loi:', loi));
    hienDaiUndo();
    const cuonMoi = layCuon();
    if (cuonMoi) cuonMoi.scrollTop = viTriCuon;
    capNhatBongCuon();
  } catch (loi) {
    console.warn('[gio] khong doi duoc gio:', loi);
  } finally {
    datDangBan(false);
  }
}

/** Cap nhat so luong tren nut gio o header (minh di duong rieng nen phai tu cap nhat) */
function capNhatSoGio(gioHang) {
  const dem = gioHang?.item_count ?? 0;

  document.querySelectorAll('[ref="cartBubbleCount"]').forEach((e) => {
    e.textContent = dem < 100 ? String(dem) : '';
    e.classList.toggle('hidden', dem === 0);
  });
  document.querySelectorAll('[ref="cartBubble"]').forEach((e) => {
    e.classList.toggle('visually-hidden', dem === 0);
    /* (76c) NHÚN BONG BÓNG khi SỐ ĐỔI (học Horizon `cart-icon.js` + `cart-bubble--animating`
       — CSS đã có sẵn trong snippets/header-actions.liquid, chỉ thiếu chỗ gật công tắc):
       số mới ≠ số đang hiển thị ⇒ gắn lớp nhún ~0.9s rồi gỡ. */
    const soCu = Number(e.dataset.bbDem || '');
    if (dem > 0 && soCu !== dem) {
      e.dataset.bbDem = String(dem);
      e.classList.remove('cart-bubble--animating');
      void e.offsetWidth; /* ép vẽ lại ⇒ hoạt ảnh chạy lại từ đầu mỗi lần */
      e.classList.add('cart-bubble--animating');
      window.setTimeout(() => e.classList.remove('cart-bubble--animating'), 900);
    } else if (dem === 0) {
      e.dataset.bbDem = '0';
    }
  });

  try {
    sessionStorage.setItem('cart-count', JSON.stringify({ value: String(dem), timestamp: Date.now() }));
  } catch {
    /* trinh duyet chan sessionStorage */
  }
}

/** Hien dai "Removed … / Undo" neu vua xoa mon
 *  PHIẾU 72 (16/10/2026): dải này nay nằm ở CHÂN GIỎ (ngay trên khối tóm tiền)
 *  và TỰ ẨN SAU 4 GIÂY (anh chốt — 6 giây dài quá). */
let henUndo = null;

/** (17/10/2026) Đo chiều cao chân giỏ để đặt toast Undo NGAY TRÊN Total, cách 12px.
 *  Giỏ rỗng: chân giỏ `display:none` ⇒ offsetHeight = 0 ⇒ toast ở đáy ngăn kéo. */
function capNhatChieuCaoChan() {
  const gio = document.querySelector('#cart-drawer .bb-gio');
  const chan = document.querySelector('#cart-drawer .bb-gio__chan');
  if (!gio) return;
  gio.style.setProperty('--bb-chan-h', ((chan && chan.offsetHeight) || 0) + 'px');
}

function hienDaiUndo() {
  const dai = document.querySelector('#cart-drawer [data-bb-undo]');
  if (!dai) return;

  /* Toast absolute ⇒ phải biết chiều cao footer hiện tại (0 khi giỏ rỗng) */
  capNhatChieuCaoChan();

  if (henUndo) {
    clearTimeout(henUndo);
    henUndo = null;
  }

  dai.hidden = !vuaXoa;
  if (vuaXoa) {
    const oTen = dai.querySelector('[data-bb-undo-ten]');
    if (oTen) oTen.textContent = vuaXoa.ten;

    /* 4 giây tính từ lần ĐẦU HIỆN, KHÔNG reset mỗi lần MutationObserver gọi lại. */
    if (!daHenUndo) {
      daHenUndo = true;
      lucHienUndo = Date.now();
    }
    const conLai = Math.max(0, 4000 - (Date.now() - lucHienUndo));
    if (conLai <= 0) {
      dai.hidden = true;
    } else {
      henUndo = setTimeout(() => {
        dai.hidden = true;
      }, conLai);
    }
  } else {
    daHenUndo = false;
    lucHienUndo = 0;
  }
}

/* Toast Undo absolute cần biết chiều cao footer: cập nhật khi mở giỏ + khi đổi cỡ màn hình. */
document.addEventListener('theme-drawer:open', () => {
  capNhatChieuCaoChan();
  setTimeout(capNhatChieuCaoChan, 80);
});
let henChieuCaoChan = 0;
window.addEventListener('resize', () => {
  clearTimeout(henChieuCaoChan);
  henChieuCaoChan = setTimeout(capNhatChieuCaoChan, 150);
});

/* ============================================================================
   (P79 · 17/10/2026) GIỮ DẢI "REMOVED · UNDO" HIỆN SAU KHI GIỎ VẼ LẠI
   ----------------------------------------------------------------------------
   LỖI ĐO ĐƯỢC (ảnh + số): bấm Remove ⇒ dải Undo nháy hiện rồi BIẾN MẤT ngay,
   vì lần vẽ lại CUỐI CÙNG của giỏ (HTML máy chủ trả về) thay cả `.bb-gio` —
   dải Undo mới mang sẵn `hidden`. Trước đây `hienDaiUndo()` chỉ chạy sau lần
   vẽ của MÌNH nên lần vẽ sau đó "nuốt" mất trạng thái hiện.
   Cách chữa: theo dõi thay đổi DOM trong ngăn giỏ; hễ còn `vuaXoa` thì gọi lại
   `hienDaiUndo()` (gộp 40ms) ⇒ dải Undo luôn hiện đủ 4 giây dù ai vẽ lại.
   Không đụng logic xoá/undo — chỉ giữ trạng thái hiển thị.
   ============================================================================ */
function ganTheoDoiUndo() {
  const khu = document.querySelector('#cart-drawer');
  if (!khu || !window.MutationObserver || khu.__bbTheoDoiUndo) return;
  khu.__bbTheoDoiUndo = true;
  let hen = 0;
  new MutationObserver(() => {
    if (!vuaXoa) return;
    clearTimeout(hen);
    hen = setTimeout(hienDaiUndo, 40);
  }).observe(khu, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ganTheoDoiUndo, { once: true });
} else {
  ganTheoDoiUndo();
}
document.addEventListener('theme-drawer:open', ganTheoDoiUndo);


/* ============ LAM MOI RUOT GIO (11/10/2026 · p53) ============
   Vi sao co khoi nay: truoc day CHI nhung cho tu goi /cart/add.js trong theme nay
   (the o trang chu, nut mua o PDP) moi ve lai ruot gio. Khach them hang tu cho khac
   (quick-add o bo suu tap, thanh mua dinh, khoi goi y…) thi ruot gio CU ⇒ mo ra thay
   thieu mon. Nay:
     · 1 cho lo viec THAY ruot gio (`thayRuot`) — dung chung cho moi duong;
     · 1 cho lo viec TU LAY lai HTML moi (`veLaiRuotGio`) khi nghe thay gio da doi. */

/** Moc thoi gian lan cuoi thay ruot gio — de khong tai lai 2 lan lien */
let lanThayRuot = 0;
/** Dang tai lai ruot gio? (chong goi chong) */
let dangTaiRuot = false;

/** Thay `.bb-gio` bang HTML may chu tra ve. GIU vi tri cuon. @returns {boolean} */
function thayRuot(html) {
  const cu = layRuot();
  if (!html || !cu) return false;
  const moi = new DOMParser().parseFromString(html, 'text/html').querySelector('.bb-gio');
  if (!moi) return false;

  /* (76c) MÓN MỚI ⇒ đánh dấu để TRƯỢT VÀO mượt (học Horizon lớp `.adding`):
     món nào KHÔNG có ở bản cũ (theo `data-variant`) thì được gắn `.bb-gio__mon--moi`. */
  const variantsCu = new Set([...cu.querySelectorAll('[data-bb-mon]')].map((m) => m.dataset.variant));
  moi.querySelectorAll('[data-bb-mon]').forEach((m) => {
    if (!variantsCu.has(m.dataset.variant)) m.classList.add('bb-gio__mon--moi');
  });
  /* 🔴 76 l (17/10/2026) — ĐÃ BỎ lớp DÌM MỜ `.bb-gio--vua-thay` (opacity 0,55 → 1 trong 0,18s).
     Anh Trung: *“mỗi lần thêm hay bớt sản phẩm nó phải giật một cái”*.
     Đo `_TOOLS/_p76l-soi-giat.py`: bố cục KHÔNG nhảy (delta vị trí/chiều cao/cuộn/món = 0) nhưng
     **độ mờ của cả khối giỏ tụt còn 0,55** ở MỖI lượt thêm/bớt ⇒ chính cái “nháy mờ” đó là cú giật
     (nó còn bị nhân đôi với View Transition 76f: chụp-cũ ≈1,0 → chụp-mới ≈0,55 rồi mới sáng lại).
     Giờ để VIEW TRANSITION lo phần mượt khi giỏ đang mở; đường dự phòng (giỏ đóng / máy cũ /
     giảm chuyển động) thì thay thẳng — không ai nhìn thấy nên không cần dìm.
     🔁 LÙI BÀI: thêm lại đúng 1 dòng `moi.classList.add('bb-gio--vua-thay');` (CSS còn nguyên). */

  const viTri = layCuon()?.scrollTop ?? 0;

  /* Làm nốt SAU khi DOM đã đổi (chạy trong callback View Transition hoặc chạy thẳng) */
  const xongRuot = () => {
    const cuonMoi = layCuon();
    if (cuonMoi) cuonMoi.scrollTop = viTri; /* giữ đúng chỗ khách đang xem */
    capNhatBongCuon();
    /* PHIẾU 72 (16/10/2026): ruột giỏ VỪA đổi ⇒ vẽ lại cột “Recently viewed”
       (lúc này mới lọc được món đang có trong giỏ). */
    if (typeof veCotRV === 'function') veCotRV();
    capNhatChieuCaoChan();
    /* (P86 · 17/10/2026) VẼ LẠI “ADD A LITTLE EXTRA” **SAU KHI DOM MỚI ĐÃ THAY XONG**.
       LỖI ĐO ĐƯỢC (ảnh + số): `lamMoi()` cũ gọi `taiGoiY()` NGAY sau `thayRuot()`, nhưng
       `thayRuot()` có thể trả về TRƯỚC khi callback View Transition thay `.bb-gio` ⇒
       gợi ý được vẽ vào khối CŨ (đã bị gỡ), khối MỚI vẫn mang `hidden` ⇒ cả khối
       “Add a little extra” biến mất sau khi thêm/xoá. Nay gọi trong `xongRuot()`
       — chạy sau `cu.replaceWith(moi)` nên luôn bám đúng khối mới. */
    daTaiGoiY = null;
    taiGoiY();
    /* (76e) Nếu lúc THÊM hàng giỏ đang TRỐNG, mình đã “gác” việc mở giỏ ⇒ mở NGAY BÂY GIỜ
       khi hàng mới đã về (học Horizon: không bao giờ khoe giỏ rỗng). */
    if (choMoSau) {
      choMoSau = false;
      document.querySelector('#cart-drawer')?.open?.();
    }
  };

  lanThayRuot = Date.now();

  /* (76f) CHỐNG “GIẬT” — HỌC HORIZON (`component-cart-items.js` bọc `startViewTransition`):
     khi giỏ ĐANG MỞ, thay ruột trong VIEW TRANSITION để chuyển CŨ → MỚI mềm (0.22s) thay vì
     “bụp” một khung hình (đo 76f: một cú nhảy 96–146px lúc máy chủ chốt sổ).
     Máy cũ / bật giảm-chuyển-động ⇒ thay thẳng như cũ. */
  const dlg = document.querySelector('#cart-drawer dialog');
  const dangMo = !!(dlg && dlg.getBoundingClientRect().left < window.innerWidth - 40);
  const giamCĐ = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if (dangMo && !giamCĐ && typeof document.startViewTransition === 'function') {
    try {
      document.startViewTransition(() => {
        cu.replaceWith(moi);
        xongRuot();
      });
      return true;
    } catch (e) {
      /* rơi xuống đường thường bên dưới */
    }
  }
  cu.replaceWith(moi);
  xongRuot();
  return true;
}

/** Thay ruot gio ROI canh lai dai Undo + lay lai goi y (dung cho PDP / thanh mua dinh) */
function lamMoi(html) {
  const xong = thayRuot(html);
  if (xong) {
    hienDaiUndo();
  }
  return xong;
}

/** TU LAY lai HTML ruot gio tu Shopify (Section Rendering API) khi gio doi o NOI KHAC */
async function veLaiRuotGio() {
  if (dangTaiRuot || !layRuot()) return;
  dangTaiRuot = true;
  datDangBan(true);
  const t0 = Date.now();          /* mốc bắt đầu tải — xem chống ghi đè bên dưới */
  try {
    const tra = await fetch(`${location.pathname}?section_id=${SECTION}`, {
      headers: { Accept: 'text/html' },
    });
    const html = await tra.text();
    /* Ai đó VỪA thay ruột giỏ SAU khi mình bắt đầu tải (dữ liệu mới hơn mình) ⇒ BỎ,
       không ghi đè, kẻo khách thấy giỏ cũ thiếu món. */
    if (html && html.indexOf('bb-gio') >= 0 && lanThayRuot < t0) {
      lamMoi(html);
      /* (p53) Bong bóng giỏ ở header cho CHẮC: sự kiện không phải lúc nào cũng kèm số
         (đo thật: phát sự kiện thường ⇒ ruột giỏ đúng mà bong bóng đứng ở 0)
         ⇒ hỏi luôn `/cart.js` (nhỏ, nhanh) rồi cập nhật. */
      try {
        const gioHang = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        capNhatSoGio(gioHang);
      } catch {
        /* mạng lỗi ⇒ thôi, đã có ruột giỏ đúng */
      }
    }
  } catch (loi) {
    console.warn('[gio] khong lam moi duoc ruot gio:', loi);
  } finally {
    dangTaiRuot = false;
    datDangBan(false);
  }
}

/* Cho PDP / thanh mua dinh / bat ky cho nao khac dung lai (khong phai viet lai) */
window.bambooveGio = {
  thayRuot: lamMoi,
  veLai: veLaiRuotGio,
  dem: capNhatSoGio,
  ban: datDangBan,
  mo: () => document.querySelector('#cart-drawer')?.open?.(),
  /* (76e) MỞ TRƯỚC KHI THÊM — học Horizon: giỏ ĐÃ CÓ HÀNG ⇒ mở NGAY (khỏi chờ, không spinner);
     giỏ TRỐNG ⇒ GÁC việc mở, `thayRuot` sẽ mở khi hàng mới về (tránh khoe giỏ rỗng). */
  moTruocKhiThem: () => {
    if (document.querySelector('#cart-drawer [data-bb-mon]')) {
      document.querySelector('#cart-drawer')?.open?.();
    } else {
      choMoSau = true;
    }
  },
  /* (76 k · 17/10/2026) Dùng khi thêm hàng TỪ **MODAL QUICK-ADD** — anh Trung chốt:
     *“hiển vào giỏ trước rồi chạy cái kia sau… load xong thì hiện giỏ ra”* ⇒ LUÔN GÁC việc mở:
     máy chủ trả lời + ruột giỏ vẽ xong thì giỏ mới hiện (không bao giờ khoe giỏ cũ thiếu món). */
  moKhiHangVe: () => {
    choMoSau = true;
    /* Lưới an toàn: thêm hàng LỖI (mạng hỏng) ⇒ đừng để cờ treo, kẻo lần vẽ giỏ KHÁC mở giỏ bất ngờ */
    setTimeout(() => {
      choMoSau = false;
    }, 8000);
  },
  /* (76f) Đang chạy 1 lệnh đổi giỏ? — để các đường khác (thẻ bên ngoài) biết mà chờ/nhường */
  dangChay: () => dangChayLenh,
};

/* ============ 4) GOI Y THEM TRONG GIO ("You might also like") ============
   Hoc tu GYMSHARK: gio cua ho co carousel goi y (goi API `minicart/recommendations/popularity`
   va `minicart/recommendations/promotions`, co lop `minicart-recommendations-skeleton`).
   Minh dung API CO SAN cua Shopify: GET /recommendations/products.json => KHONG can app.
   Goi y lay theo san pham DAU TIEN trong gio; giỏ doi thi lay lai. */
let daTaiGoiY = null;

function veGoiY(khoi, ds, dsSp) {
  ds.innerHTML = dsSp
    .map((sp) => {
      const anh = sp.featured_image
        ? `<img class="bb-gio__goiy-anh" src="${sp.featured_image}" alt="${sp.title || ''}" width="68" height="68" loading="lazy">`
        : '';
      const gia = '$' + (Number(sp.price) / 100).toFixed(2);
      const duong = String(sp.url || '').split('?')[0];
      /* VIỆC 5 (16/10/2026 · phiếu 72): nút “+ Add” — chọn biến thể ĐẦU TIÊN còn hàng */
      const bienThe = (sp.variants || []).find((v) => v.available) || (sp.variants || [])[0];
      const nutThem = bienThe
        ? `<button type="button" class="bb-gio__goiy-them" data-bb-goiy-them="${bienThe.id}">+ Add</button>`
        : '';
      /* 16/10/2026 (phiên 75 c) — GÓI NHỎ nằm NGANG (kiểu Gymshark “Add a little extra”):
         ảnh 68px · khối tên+giá · nút “+ Add”. */
      return (
        `<li class="bb-gio__goiy-o"><a href="${duong}">${anh}` +
        `<span class="bb-gio__goiy-tin"><span class="bb-gio__goiy-ten-o">${sp.title}</span>` +
        `<span class="bb-gio__goiy-gia">${gia}</span></span></a>${nutThem}</li>`
      );
    })
    .join('');
  khoi.hidden = dsSp.length === 0;
}

/** B18 (16/10/2026 · phiếu 72): hiện 4 khung xám (skeleton) trong lúc CHỜ /recommendations/products.json.
 *  Đo trước khi sửa (_DO\p72-do-that.txt): khối gợi ý TRỐNG trong lúc chờ (`o_skeleton = 0`).
 *  Học Gymshark (lớp `minicart-recommendations-skeleton`). `veGoiY()` thay sạch innerHTML
 *  ⇒ skeleton tự mất khi có dữ liệu; fetch lỗi ⇒ khối bị ẩn như cũ. */
function hienSkeleton(khoi, ds, soO) {
  khoi.hidden = false;
  let html = '';
  for (let i = 0; i < soO; i++) {
    html +=
      '<li class="bb-gio__goiy-o bb-gio__goiy-skeleton" aria-hidden="true">' +
      '<span class="bb-gio__goiy-skeleton-anh"></span>' +
      '<span class="bb-gio__goiy-skeleton-chu"></span>' +
      '<span class="bb-gio__goiy-skeleton-chu bb-gio__goiy-skeleton-chu--ngan"></span>' +
      '</li>';
  }
  ds.innerHTML = html;
}

/* ============================================================================
   16/10/2026 (phiên 75 d) — “ADD A LITTLE EXTRA” LẤY ĐÚNG DÒNG **CREW** (anh Trung chốt, tạm thời):
   · NGUON_EXTRA = 'crew' ⇒ CHỈ sản phẩm `product_type = 'Crew Socks'` (5 đôi · $29.50),
     **KHÔNG** lấy knee-high; bỏ món đang có trong giỏ; tối đa 8.
   · NGUON_EXTRA = 'goiy' ⇒ quay lại như trước (Shopify `/recommendations` theo món đầu trong giỏ).
   Dữ liệu: `/products.json` (danh sách thật của shop) — không cần app.
   LÙI BÀI: đổi NGUON_EXTRA về 'goiy'.
   ============================================================================ */
const NGUON_EXTRA = 'crew';
const LOAI_EXTRA = 'Crew Socks';
const TOI_DA_EXTRA = 8;
let cacheExtra = null;

async function taiExtra() {
  const khoi = document.querySelector('#cart-drawer [data-bb-goiy]');
  const ds = document.querySelector('#cart-drawer [data-bb-goiy-ds]');
  if (!khoi || !ds) return;

  hienSkeleton(khoi, ds, 4); /* B18: khung xám trong lúc chờ */

  try {
    if (!cacheExtra) {
      const j = await fetch('/products.json?limit=250').then((r) => r.json());
      cacheExtra = (j && j.products) || [];
    }

    /* bỏ những món ĐANG CÓ TRONG GIỎ (khách không cần thấy lại) */
    const dangCo = new Set(
      Array.from(document.querySelectorAll('#cart-drawer .bb-gio__mten[href*="/products/"]')).map(
        (a) => String(a.getAttribute('href')).split('/products/')[1]?.split('?')[0] || ''
      )
    );
    let dsSp = cacheExtra
      .filter(
        (p) =>
          String(p.product_type || '').toLowerCase() === LOAI_EXTRA.toLowerCase() && !dangCo.has(p.handle)
      )
      .slice(0, TOI_DA_EXTRA);

    /* 🔴 76 m (17/10/2026) — KHỐI “ADD A LITTLE EXTRA” KHÔNG ĐƯỢC BIẾN MẤT.
       Anh Trung: *“add xong thì mất luôn cái phần add a little… và recent view”*.
       Vì sao: shop chỉ có 5 màu CREW; giỏ đủ 5 màu ⇒ sau khi lọc “món ĐANG CÓ trong giỏ” danh sách
       = RỖNG ⇒ code cũ đặt `hidden` cho CẢ khối (tiêu đề + 2 TAB cũng mất theo, khách tưởng lỗi).
       Nay: ① còn ít hơn 4 món ⇒ BỔ SUNG các đôi KHÁC chưa có trong giỏ (ưu tiên CREW trước, vẫn giữ
       đúng luật “KHÔNG hiện món đã nằm trong giỏ”); ② đã có HẾT mọi đôi ⇒ GIỮ KHỐI + 1 dòng báo. */
    if (dsSp.length < 4) {
      const daCoDs = new Set(dsSp.map((x) => x.handle));
      const them = cacheExtra.filter(
        (p) =>
          !dangCo.has(p.handle) &&
          !daCoDs.has(p.handle) &&
          String(p.product_type || '').toLowerCase().indexOf('sock') >= 0
      );
      dsSp = dsSp.concat(them.slice(0, TOI_DA_EXTRA - dsSp.length));
    }

    ds.innerHTML = dsSp
      .map((sp) => {
        /* 16/10/2026 (75 f) — SỬA LỖI ẢNH: endpoint `/products.json` KHÔNG có trường `featured_image`
           (nó chỉ có `images[]`) ⇒ thẻ bị mất ảnh. Nay lấy `featured_image` nếu có, KHÔNG thì
           lấy `images[0].src`. */
        const anhUrl =
          sp.featured_image || (Array.isArray(sp.images) && sp.images[0] && sp.images[0].src) || '';
        const anh = anhUrl
          ? `<img class="bb-gio__goiy-anh" src="${anhUrl}" alt="${sp.title || ''}" width="56" height="56" loading="lazy">`
          : '';
        const v0 = (sp.variants || [])[0] || {};
        const gia = v0.price ? '$' + Number(v0.price).toFixed(2) : '';
        const duong = '/products/' + sp.handle;
        const bienThe = (sp.variants || []).find((v) => v.available) || v0;
        const nutThem =
          bienThe && bienThe.id
            ? `<button type="button" class="bb-gio__goiy-them" data-bb-goiy-them="${bienThe.id}" data-bb-them-ngay="1">+ Add</button>`
            : '';
        return (
          `<li class="bb-gio__goiy-o"><a href="${duong}">${anh}` +
          `<span class="bb-gio__goiy-tin"><span class="bb-gio__goiy-ten-o">${sp.title}</span>` +
          `<span class="bb-gio__goiy-gia">${gia}</span></span></a>${nutThem}</li>`
        );
      })
      .join('');
    if (dsSp.length === 0) {
      ds.innerHTML =
        '<li class="bb-gio__goiy-rong">You have everything from this collection in your bag.</li>';
    }

    /* 76 m — NẠP TRƯỚC trang quick-add cho 3 món đầu (lệch nhịp) ⇒ bấm “+ Add” là popup hiện
       NỘI DUNG nhanh hơn hẳn (anh: “bấm nút add… phải load một lúc mới lên”). */
    dsSp.slice(0, 3).forEach((sp, i) => {
      setTimeout(() => napTruocQuickAdd(sp.handle), 350 + i * 350);
    });

    khoi.hidden = false; /* 76 m — LUÔN giữ khối + 2 TAB (đừng để khách tưởng bị lỗi) */
  } catch (loi) {
    console.warn('[gio] khong lay duoc danh sach Crew:', loi);
    /* 76 m — lỗi mạng thì VẪN giữ khối + 1 dòng báo (trước đây ẩn cả khối, kèm 2 tab) */
    ds.innerHTML = '<li class="bb-gio__goiy-rong">Couldn’t load suggestions — please try again.</li>';
    khoi.hidden = false;
  }
}

async function taiGoiY(buocLai) {
  /* 75 d: “Add a little extra” đang lấy dòng CREW ⇒ mọi chỗ gọi taiGoiY() đều đi qua đây */
  if (NGUON_EXTRA === 'crew') return taiExtra();
  const khoi = document.querySelector('#cart-drawer [data-bb-goiy]');
  const ds = document.querySelector('#cart-drawer [data-bb-goiy-ds]');
  if (!khoi || !ds) return;

  const mon = document.querySelector('#cart-drawer [data-bb-mon][data-product]');
  const pid = mon?.dataset.product || '';
  if (!pid) {
    khoi.hidden = true;
    return;
  }
  if (!buocLai && daTaiGoiY === pid) return; // da co roi, khoi goi lai (buocLai = bam tab, ve lai)

  daTaiGoiY = pid;
  hienSkeleton(khoi, ds, 4);   // B18: khung xám NGAY khi bắt đầu chờ (học Gymshark)
  try {
    const tra = await fetch(
      `/recommendations/products.json?product_id=${encodeURIComponent(pid)}&limit=10&intent=related`
    ).then((r) => r.json());
    veGoiY(khoi, ds, tra?.products || []);
  } catch (loi) {
    console.warn('[gio] khong lay duoc goi y:', loi);
    khoi.hidden = true;
  }
}

/* ============================ UY QUYEN SU KIEN ============================ */

/* Bam trong gio: so luong ( − / + ) · xoa mon · undo */
document.addEventListener(
  'click',
  async (ev) => {
    const nut = ev.target instanceof Element ? ev.target.closest('#cart-drawer button') : null;
    if (!nut) return;

    const mon = nut.closest('[data-bb-mon]');
    const line = Number(mon?.dataset.line || 0);

    // 1) nut so luong
    if (nut.matches('[data-bb-tru], [data-bb-cong]')) {
      ev.preventDefault();
      const oSl = mon?.querySelector('[data-bb-sl]');
      const slHienTai = parseInt(oSl?.textContent ?? '1', 10);
      const moi = nut.matches('[data-bb-cong]') ? slHienTai + 1 : Math.max(1, slHienTai - 1);
      if (moi !== slHienTai) {
        /* (76e) HỌC HORIZON — “Cart buttons are always managed client-side”:
           hiện SỐ MỚI NGAY (không làm mờ cả dòng, không spinner) + shimmer nhẹ trên số & Tổng;
           máy chủ trả về thì `thayRuot` chốt lại con số + tiền (không lệch nguồn tính). */
        if (oSl) oSl.textContent = String(moi);
        nhaySo(oSl);
        nhaySo(document.querySelector('#cart-drawer [data-bb-tong-co-ship]'));
        /* (76f) GỘP LỆNH: bấm +/− liên tục ⇒ cập nhật số trên màn hình từng nhịp, nhưng
           HỦY hẹn cũ và hẹn 350ms gửi ĐÚNG 1 request với số CUỐI (y Horizon debounce 300ms). */
        clearTimeout(henSoLuong.get(line));
        henSoLuong.set(
          line,
          window.setTimeout(() => {
            henSoLuong.delete(line);
            const oDong = document.querySelector('#cart-drawer [data-bb-mon][data-line="' + line + '"]');
            const soCuoi = parseInt(oDong?.querySelector('[data-bb-sl]')?.textContent ?? '', 10);
            if (!Number.isFinite(soCuoi)) return; /* dòng đã bị xoá/vẽ lại ⇒ bỏ hẹn */
            goi(API.change, { line, quantity: soCuoi });
          }, 350)
        );
      }
      return;
    }

    // 2) nut "Remove" — giu lai 1 ban de co the Undo
    if (nut.matches('[data-bb-xoa]')) {
      ev.preventDefault();
      vuaXoa = {
        variantId: mon?.dataset.variant,
        quantity: parseInt(mon?.querySelector('[data-bb-sl]')?.textContent ?? '1', 10),
        ten: mon?.querySelector('.bb-gio__mten')?.textContent?.trim() ?? '',
      };
      /* Món mới bị xoá ⇒ đếm lại 4 giây từ đầu */
      daHenUndo = false;
      lucHienUndo = 0;
      /* (76c) THU GỌN dòng NGAY (thay vì chỉ làm mờ) — mắt thấy “đã xoá” tức thì,
         y Horizon: animate dòng trước rồi mới thật sự bỏ. */
      clearTimeout(henSoLuong.get(line)); /* (76f) hủy hẹn +/− đang chờ của DÒNG NÀY */
      henSoLuong.delete(line);
      dongMon(mon);
      /* (76e) shimmer nhẹ trên Tổng (y Horizon: `cartTotal?.shimmer()` — không spinner) */
      nhaySo(document.querySelector('#cart-drawer [data-bb-tong-co-ship]'));
      await goi(API.change, { line, quantity: SO_DE_XOA });
      return;
    }

    // 3) nut "Undo"
    if (nut.matches('[data-bb-undo-nut]')) {
      ev.preventDefault();
      const xoa = vuaXoa;
      vuaXoa = null;
      daHenUndo = false;
      lucHienUndo = 0;
      if (xoa?.variantId) {
        /* (76c) KHÔNG “làm mờ cả giỏ” nữa — máy chủ vẽ lại rồi, món quay về sẽ TỰ
           trượt vào vì `thayRuot` đánh dấu `.bb-gio__mon--moi` cho món mới xuất hiện. */
        henSoLuong.forEach((t) => clearTimeout(t)); /* (76f) dọn mọi hẹn +/− đang chờ */
        henSoLuong.clear();
        await goi(API.add, { items: [{ id: Number(xoa.variantId), quantity: xoa.quantity || 1 }] });
      }
    }
  },
  true
);

/* ============================================================================
   76 k (17/10/2026) — THÊM HÀNG TỪ MODAL: TỰ GỬI ĐƠN (đúng luồng P76c/P76e đã kiểm chứng)
   Vì sao KHÔNG để form của Horizon tự gửi: Horizon phát sự kiện giỏ TRƯỚC khi máy chủ thêm hàng,
   rồi `cart-drawer.js` (auto-open) mở giỏ ngay khi `promise` trả lời — trong khi ruột giỏ của
   Bamboove phải FETCH RIÊNG nên về sau ⇒ khách thấy giỏ mở ra TRỐNG rồi mới hiện món (đo `_p76k`:
   mở ở 1955ms, món hiện ở 2930ms).
   Cách chữa (xem khối click bên dưới): chặn form, TỰ POST `/cart/add.js` kèm `sections` ⇒ máy chủ
   trả LUÔN HTML giỏ mới trong cùng phản hồi ⇒ vẽ ruột giỏ XONG mới mở giỏ (không còn khoảng trống).
   ============================================================================ */

/** (76 k) Báo nhỏ khi thêm hàng từ modal THẤT BẠI (mạng / hết hàng) — tự tắt sau 4 giây. */
function baoLoiThemHang() {
  const cu = document.querySelector('.bb-bao-loi-them');
  if (cu) cu.remove();
  const el = document.createElement('div');
  el.className = 'bb-bao-loi-them';
  el.setAttribute('role', 'alert');
  el.textContent = 'Không thêm được vào giỏ — bạn thử lại nhé.';
  el.style.cssText =
    'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;' +
    'background:#1f1f1f;color:#fff;padding:10px 16px;border-radius:999px;' +
    'font-family:inherit;font-size:13px;font-weight:600;box-shadow:0 8px 24px rgb(0 0 0 / 25%)';
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 4000);
}

/* Gio doi o noi khac (them tu the san pham / trang khac):
   them mon MOI thi quen mon vua xoa; luon canh lai dai Undo. */
for (const ten of SU_KIEN_GIO) {
  document.addEventListener(ten, (ev) => {
    if (ev?.detail?.action === 'add' || ev?.action === 'add') vuaXoa = null;
    hienDaiUndo();

    /* (p53) Gio doi o NOI KHAC (quick-add o bo suu tap, the o trang chu, thanh mua dinh…) ⇒
       ruot gio dang CU ⇒ tu lay lai HTML moi. Ai vua tu thay (trong 2,5 giay) thi bo qua.
       P65-CART-FIX: tang nguong 1200 -> 2500 vi sau khi sua P65, `goi()` set `lanThayRuot` NGAY
       (truoc khi fetch) nen cua so 1200ms qua ngan, co the van goi lai fetch 1 lan nua. */
    if (Date.now() - lanThayRuot > 2500) veLaiRuotGio();

    /* So tren bong bong gio o header: lay tu chinh su kien, khoi goi them API */
    ev?.promise?.then?.(({ detail }) => {
      if (typeof detail?.itemCount === 'number') capNhatSoGio({ item_count: detail.itemCount });
    })?.catch?.(() => {});
  });
}

/* Ngan keo vua mo => canh lai dai Undo cho dung trang thai + lay goi y */
document.addEventListener('theme-drawer:open', () => {
  hienDaiUndo();
  taiGoiY();
  capNhatBongCuon(); // mo lai gio: canh lai do bong theo dung vi tri cuon
});

/* Vao trang: neu gio dang co mon thi lay goi y luon */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', taiGoiY);
} else {
  taiGoiY();
}

/* ===================== BO CUC MOI (10/10/2026 · phien 46) ===================== */

/* Cuon vung giua => do bong dau gio / chan gio.
   Dung pha `capture` o `document` vi su kien `scroll` KHONG noi bot, ma ruot gio lai bi
   Bamboove ve lai sau moi lan doi => gan truc tiep vao phan tu se mat lang le. */
document.addEventListener(
  'scroll',
  (ev) => {
    if (ev.target instanceof Element && ev.target.matches('#cart-drawer [data-bb-cuon]')) {
      capNhatBongCuon();
    }
  },
  true
);

/* Nut Copy ma nguoi moi trong chan gio (cho khach dan tay o buoc thanh toan) */
document.addEventListener('click', async (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-ma-chep]') : null;
  if (!nut) return;
  ev.preventDefault();

  const ma = nut.closest('[data-bb-ma]')?.dataset.bbMa || '';
  if (!ma) return;

  const chuCu = nut.textContent;
  try {
    await chepChu(ma);
    nut.textContent = 'Copied';
  } catch {
    nut.textContent = 'Copy failed';
  }
  setTimeout(() => {
    nut.textContent = chuCu;
  }, 2000);
});

/* Bam vao NEN MO => dong gio (1 trong 4 duong dong cua ban chot v36).
   Bamboove mo gio dang NON-MODAL tren desktop nen `#onBackdropClick` cua no khong bat duoc
   cu bam ngoai dialog; lop nen `.bb-gio-nen` tu nhan cu bam nay. */
document.addEventListener('click', (ev) => {
  const nen = ev.target instanceof Element ? ev.target.closest('#cart-drawer .bb-gio-nen') : null;
  if (!nen) return;
  document.querySelector('#cart-drawer')?.close?.();
});

/* ============================================================================
   PHIẾU 72 (16/10/2026) — GIỎ MỚI · NHÓM 1 (JS)
   ⑥ Ô NHẬP MÃ GIẢM GIÁ: dùng đường có sẵn của Shopify `/discount/<MÃ>?redirect=<trang hiện tại>`
      ⇒ KHÔNG cần app. Quay lại trang cũ kèm `?bb_gio=1` để TỰ MỞ LẠI giỏ cho khách thấy kết quả.
   ⑦ GHI CHÚ ĐƠN: lưu vào `cart.note` qua `/cart/update.js` (gõ xong 700ms mới lưu).
   Gắn ở `document` (uỷ quyền sự kiện) ⇒ không mất khi giỏ được vẽ lại.
   LÙI BÀI: xoá đúng khối này.
   ============================================================================ */

/* ⑥ — bấm Apply (hoặc Enter) ⇒ áp mã */
document.addEventListener('click', (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-manhap-nut]') : null;
  if (!nut) return;
  ev.preventDefault();

  const khoi = nut.closest('[data-bb-manhap]');
  const o = khoi?.querySelector('[data-bb-manhap-o]');
  const ma = (o?.value || '').trim();

  if (!ma) {
    o?.focus();
    return;
  }

  /* giữ nguyên trang đang xem + đánh dấu để lúc quay lại tự mở giỏ */
  const ve = location.pathname + (location.search ? location.search + '&' : '?') + 'bb_gio=1';
  location.href = '/discount/' + encodeURIComponent(ma) + '?redirect=' + encodeURIComponent(ve);
});

/* Enter trong ô mã = bấm Apply */
document.addEventListener('keydown', (ev) => {
  if (ev.key !== 'Enter') return;
  const o = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-manhap-o]') : null;
  if (!o) return;
  ev.preventDefault();
  o.closest('[data-bb-manhap]')?.querySelector('[data-bb-manhap-nut]')?.click();
});

/* ⑦ — ghi chú đơn */
let henNote = null;
document.addEventListener('input', (ev) => {
  const o = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-note-o]') : null;
  if (!o) return;
  if (henNote) clearTimeout(henNote);
  henNote = setTimeout(() => {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: o.value }),
    }).catch(() => {
      /* mạng lỗi: giữ nguyên chữ khách đã gõ, không báo lỗi rối */
    });
  }, 700);
});

/* ⑥b — vừa áp mã xong (URL có bb_gio=1) ⇒ TỰ MỞ LẠI giỏ rồi xoá tham số cho sạch URL */
if (/[?&]bb_gio=1/.test(location.search)) {
  const moLai = () => {
    if (window.bambooveGio?.mo) window.bambooveGio.mo();
    else document.querySelector('#cart-drawer')?.open?.();
  };
  const chayMo = () => setTimeout(moLai, 600);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', chayMo);
  else chayMo();

  try {
    const u = new URL(location.href);
    u.searchParams.delete('bb_gio');
    history.replaceState(null, '', u.pathname + (u.search ? u.search : '') + u.hash);
  } catch {
    /* trình duyệt cũ: để nguyên tham số, không sao */
  }
}

/* ============================================================================
   16/10/2026 · phiếu 72 — BẢN v7 (mockup v7 điểm 2): ĐÃ BỎ ⑥ NÚT TIM ♡ trên từng món.
   Thẻ món nay chỉ còn: tên · biến thể · giá (gạch + giảm) · bộ −1+ · Remove.
   🔁 LÙI BÀI: khối ⑥ (KHOA_THICH · docThich · ghiThich · danhDauTim · bắt sự kiện click)
   nằm nguyên trong _DO\_BAN-LUU\bamboove-cart-drawer.js.p72v7-truoc.bak
   ============================================================================ */

/* ============================================================================
   16/10/2026 (phiên 75 k) — “+ ADD” HIỆN CHỌN SIZE (quick-add) RỒI THÊM THẬT VÀO GIỎ
   Anh Trung: “nếu bấm add thì phải hiện lên size ý, trên máy tính thì cũng như điện thoại,
   để add nhanh, và bấm phải thêm vào giỏ hàng được luôn chứ không phải chỉ hiển thị”.
   · Sản phẩm 1 size (dòng CREW: “Grey / One size”)  ⇒ thêm THẲNG, không cần chọn.
   · Sản phẩm nhiều size (Classic 6 size · Essential 3 size) ⇒ hiện DÃY NÚT SIZE, bấm size = thêm.
   · Áp cho CẢ 3 nơi: thẻ gói “Add a little extra”, tab “Recently viewed”, cột trái máy tính.
   LÙI BÀI: khôi phục 2 hàm cũ ở commit `e83f718`.
   ============================================================================ */
let bocSizeDangMo = null;

/** Handle sản phẩm ĐANG mở trên trang (nếu đang ở trang sản phẩm).
 *  16/10/2026 (phiên 75 m) — anh Trung: “đang xem sản phẩm nào đó thì KHÔNG hiện sản phẩm đó
 *  ở recently viewed; phải xem xong, out ra tab khác / sang trang sản phẩm khác thì mới hiện”.
 *  ⇒ Trang sản phẩm in dấu `data-bb-rv-now` (trong snippet giỏ) ⇒ lọc bỏ handle đó khi vẽ.
 *  Trang khác không có dấu ⇒ không lọc gì (mọi món đã xem đều hiện). */
function handleDangXem() {
  const el = document.querySelector('#cart-drawer [data-bb-rv-now], [data-bb-rv-now]');
  return el ? String(el.getAttribute('data-bb-rv-now') || '') : '';
}

/** Tìm sản phẩm trong dữ liệu /products.json theo ID biến thể (thẻ gói Crew dùng). */
function timSanPhamTheoBienThe(id) {
  if (!cacheExtra) return null;
  return (
    cacheExtra.find((p) => (p.variants || []).some((v) => String(v.id) === String(id))) || null
  );
}

/** Nhãn SIZE của 1 biến thể (chịu được cả 2 dạng dữ liệu của Shopify). */
function nhanSize(v, opt) {
  if (!opt) return v.title || '';
  const pos = opt.position || 2;
  if (Array.isArray(v.options) && v.options[pos - 1]) return v.options[pos - 1];
  const o = v['option' + pos];
  if (o) return o;
  const phan = String(v.title || '').split(' / ');
  return phan.length > 1 ? phan[phan.length - 1] : v.title;
}

/** Danh sách size cần cho khách chọn (rỗng = không cần chọn). */
function dsSizeCua(sp) {
  const vs = sp.variants || [];
  if (vs.length <= 1) return [];
  const opt = (sp.options || []).find((o) => String(o.name).toLowerCase() === 'size');
  return vs.map((v) => ({ id: v.id, ten: nhanSize(v, opt), con: !!v.available }));
}

function dongBangSize() {
  if (bocSizeDangMo) {
    bocSizeDangMo.remove();
    bocSizeDangMo = null;
    document
      .querySelectorAll('#cart-drawer .is-mo-size')
      .forEach((e) => e.classList.remove('is-mo-size'));
  }
}

function moBangSize(card, dsSize) {
  dongBangSize();
  const boc = document.createElement('div');
  boc.className = 'bb-gio__size';
  boc.setAttribute('role', 'group');
  boc.setAttribute('aria-label', 'Choose a size');
  boc.innerHTML =
    '<span class="bb-gio__size-nhan">Choose a size</span>' +
    dsSize
      .map(
        (s) =>
          `<button type="button" class="bb-gio__size-nut${s.con ? '' : ' is-het'}"` +
          ` data-bb-size-them="${s.id}"${s.con ? '' : ' disabled'}>${s.ten}</button>`
      )
      .join('');
  card.appendChild(boc);
  card.classList.add('is-mo-size');
  bocSizeDangMo = boc;
}

/** Thêm THẬT 1 biến thể vào giỏ + vẽ lại giỏ (dùng chung cho mọi nơi). */
async function themVaoGioThat(bienTheId, nut) {
  if (!bienTheId) return;
  const chuCu = nut ? nut.textContent : '';
  if (nut) {
    nut.disabled = true;
    nut.textContent = '…';
  }
  try {
    const tra = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(bienTheId), quantity: 1 }] }),
    }).then((r) => r.json());

    if (tra && tra.id) {
      if (nut) nut.textContent = 'Added ✓';
      daTaiGoiY = null; /* giỏ đổi ⇒ lấy lại danh sách gợi ý */
      await veLaiRuotGio(); /* vẽ lại ruột giỏ */
      capNhatSoGio(await fetch('/cart.js').then((r) => r.json()));
      veCotRV();
    } else if (nut) {
      nut.textContent = 'Sold out';
    }
  } catch {
    if (nut) nut.textContent = 'Try again';
  }
  setTimeout(() => {
    if (nut) {
      nut.textContent = chuCu;
      nut.disabled = false;
    }
  }, 1400);
}

/* Bấm “+ Add” (thẻ gói Crew: data-bb-goiy-them · Recently viewed: data-bb-rv-them)
   🔴 17/10/2026 (phiên 76 g) — ANH TRUNG CHỐT: mọi nút “Add” mở **QUICK-ADD GỐC CỦA HORIZON**
   (ảnh · tên + giá · size chip · số lượng −1+ · Add to cart · Shop Pay · More payment options),
   KHÔNG còn popup `.bb-qa` tự chế.
   Đường dự phòng (trang không có khối nguồn / JS Horizon chưa nạp):
     · có ID biến thể ⇒ thêm thẳng vào giỏ (đừng để nút chết);
     · chỉ có handle  ⇒ hỏi /products/<handle>.js rồi mở BẢNG CHỌN CỠ cũ (`moBangSize`). */
document.addEventListener('click', async (ev) => {
  const nut =
    ev.target instanceof Element
      ? ev.target.closest('#cart-drawer [data-bb-goiy-them], #cart-drawer [data-bb-rv-them]')
      : null;
  if (!nut || nut.disabled) return;
  ev.preventDefault();

  const card = nut.closest('.bb-gio__goiy-o') || nut.closest('.bb-gio__cot-rv-o');
  if (!card) return;

  /* Đang mở bảng size của CHÍNH thẻ này ⇒ bấm lần 2 = đóng lại */
  if (bocSizeDangMo && card.contains(bocSizeDangMo)) {
    dongBangSize();
    return;
  }

  const idBienThe = nut.dataset.bbGoiyThem;
  const handle = nut.dataset.bbRvThem;
  const oTen = card.querySelector('.bb-gio__goiy-ten-o, .bb-gio__cot-rv-ten');
  const ten = oTen ? oTen.textContent.trim() : '';

  /* ① ĐƯỜNG CHÍNH — mở quick-add gốc Horizon.
     Nút ở “Add a little extra” chỉ có ID biến thể ⇒ tra handle từ dữ liệu /products.json đã tải. */
  if (idBienThe) {
    const spThem = timSanPhamTheoBienThe(idBienThe);
    if (spThem && spThem.handle && moQuickAddHorizon(spThem.handle, spThem.title || ten)) return;
    await themVaoGioThat(idBienThe, nut);
    return;
  }

  if (handle && moQuickAddHorizon(handle, ten)) return;

  /* ② ĐƯỜNG DỰ PHÒNG — bảng chọn cỡ cũ (CHỈ chạy khi không mở được modal Horizon) */
  let sp = null;
  if (handle) {
    try {
      sp = await fetch(`/products/${encodeURIComponent(handle)}.js`).then((r) => r.json());
    } catch {
      sp = null;
    }
  }
  if (!sp) {
    if (nut) nut.textContent = 'Try again';
    return;
  }
  const dsSize = dsSizeCua(sp);
  if (!dsSize.length) {
    await themVaoGioThat(((sp.variants || [])[0] || {}).id, nut);
    return;
  }
  moBangSize(card, dsSize);
});

/* Bấm 1 SIZE ⇒ thêm ĐÚNG biến thể của size đó vào giỏ */
document.addEventListener('click', async (ev) => {
  const nut =
    ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-size-them]') : null;
  if (!nut || nut.disabled) return;
  ev.preventDefault();
  const card = nut.closest('.bb-gio__goiy-o') || nut.closest('.bb-gio__cot-rv-o');
  const nutAdd = card
    ? card.querySelector('[data-bb-goiy-them], [data-bb-rv-them]')
    : null;
  await themVaoGioThat(nut.dataset.bbSizeThem, nutAdd || nut);
  dongBangSize();
});

/* ---------- (⑥ TIM ♡ đã bỏ — xem ghi chú đầu khối này) ---------- */

/* ============================================================================
   PHIẾU 72 · NHÓM 5 (16/10/2026) — CỘT TRÁI “RECENTLY VIEWED” (chỉ máy tính)
   · Đọc dữ liệu khách đã xem (localStorage `bamboove-da-xem-v2`, do
     assets/bamboove-recently-viewed.js ghi khi khách mở trang sản phẩm).
   · LOẠI món đang có trong giỏ · mới xem nhất lên đầu · tối đa 4 thẻ.
   · Lấy GIÁ MỚI khi mở giỏ (mỗi món 1 request nhỏ) ⇒ tránh khách thấy giá cũ.
   · CHƯA xem gì ⇒ KHÔNG hiện gì (cột ẩn, giỏ vẫn 420px như cũ).
   LÙI BÀI: xoá đúng khối này.
   ============================================================================ */
const KHOA_RV = 'bamboove-da-xem-v2';
const TOI_DA_RV = 4;

function docRV() {
  try {
    const a = JSON.parse(localStorage.getItem(KHOA_RV) || '[]');
    return Array.isArray(a) ? a : [];
  } catch {
    return [];
  }
}

function veCotRV() {
  const cot = document.querySelector('#cart-drawer [data-bb-cot-rv]');
  const ds = document.querySelector('#cart-drawer [data-bb-cot-rv-ds]');
  const dlg = document.querySelector('#cart-drawer dialog');
  if (!cot || !ds || !dlg) return;

  /* handle của các món ĐANG CÓ TRONG GIỎ (để loại ra) */
  const dangCo = new Set(
    Array.from(document.querySelectorAll('#cart-drawer .bb-gio__mten[href*="/products/"]')).map(
      (a) => String(a.getAttribute('href')).split('/products/')[1]?.split('?')[0] || ''
    )
  );

  const dsHien = docRV()
    .filter((x) => x && x.handle && !dangCo.has(x.handle) && x.handle !== handleDangXem())
    .slice(0, TOI_DA_RV);

  if (!dsHien.length) {
    cot.hidden = true;
    dlg.classList.remove('bb-co-rv');
    ds.innerHTML = '';
    return;
  }

  ds.innerHTML = dsHien
    .map(
      (x) => `<li class="bb-gio__cot-rv-o">
        <a href="${x.url || '/products/' + x.handle}">
          ${x.image ? `<img class="bb-gio__cot-rv-anh" src="${x.image}" alt="${x.title || x.handle || ''}" loading="lazy">` : ''}
          <span class="bb-gio__cot-rv-ten">${x.title || x.handle}</span>
        </a>
        <span class="bb-gio__cot-rv-gia">${x.price || ''}</span>
        <button type="button" class="bb-gio__cot-rv-them" data-bb-rv-them="${x.handle}">+ Add</button>
      </li>`
    )
    .join('');

  cot.hidden = false;
  dlg.classList.add('bb-co-rv');

  /* lấy GIÁ MỚI cho từng món (không chặn vẽ) */
  dsHien.forEach((x) => {
    fetch(`/products/${encodeURIComponent(x.handle)}.js`)
      .then((r) => r.json())
      .then((sp) => {
        const o = ds.querySelector(`[data-bb-rv-them="${x.handle}"]`);
        if (!o || !sp || !sp.price) return;
        const theGia = o.previousElementSibling;
        if (theGia) theGia.textContent = '$' + (sp.price / 100).toFixed(2);
      })
      .catch(() => {});
  });
}

/* ----------------------------------------------------------------------------
   16/10/2026 (phiên 75 k) — HÀM “+ Add” CŨ CỦA CỘT RECENTLY VIEWED ĐÃ GỠ.
   Lý do: nay mọi nút “+ Add” (thẻ gói “Add a little extra”, tab “Recently viewed”, cột trái máy tính)
   đi qua MỘT hàm chung ở khối “+ ADD HIỆN CHỌN SIZE” phía trên (tự nhận `data-bb-goiy-them`
   hoặc `data-bb-rv-them`) ⇒ giữ hàm cũ ở đây sẽ THÊM 2 LẦN mỗi cú bấm.
   LÙI BÀI: lấy lại hàm cũ ở commit `e83f718`.
   ---------------------------------------------------------------------------- */

/* vẽ lại cột khi mở giỏ / khi giỏ đổi
   ⚠️ Phải chờ ruột giỏ vẽ xong mới lọc được “món đang có trong giỏ” (đo 16/10: gọi ngay
   thì giỏ chưa có .bb-gio__mten ⇒ lọc ra rỗng ⇒ cột vẫn hiện món đang nằm trong giỏ). */
document.addEventListener('theme-drawer:open', () => {
  veCotRV();
  setTimeout(veCotRV, 600);
});
for (const ten of ['shopify:cart:lines-update', 'cart:lines-update', 'cart:update']) {
  document.addEventListener(ten, () => setTimeout(veCotRV, 500));
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', veCotRV);
} else {
  veCotRV();
}

/* ============================================================================
   PHIẾU 72 · BẢN v7 (16/10/2026) — 2 TAB GỢI Ý TRONG GIỎ (chỉ ĐIỆN THOẠI)
   Trước đây 2 tab (You may also like / Recently viewed) có MARKUP mà KHÔNG có JS
   ⇒ bấm không làm gì. Nay nối thật:
     · “You may also like” = /recommendations/products.json (hàm taiGoiY, đã có)
     · “Recently viewed”  = localStorage `bamboove-da-xem-v2` (CÙNG nguồn với cột trái máy tính)
   · MÁY TÍNH (≥1000px): hàng tab bị ẨN bằng CSS, thay bằng nhãn “You may also like”
     (cột “Recently viewed” nằm RIÊNG ở cạnh trái giỏ — NHÓM 5).
   · ĐIỆN THOẠI: 2 tab cạnh nhau; lưới thẻ 2 × 2 do CSS lo (không cuộn ngang, không mũi tên).
   LÙI BÀI: xoá đúng khối này.
   ============================================================================ */
let tabGoiY = 'goiy';

/* 16/10/2026 (phiên 75 b) — anh Trung chốt: "Recently viewed" hiện HẾT sản phẩm khách đã xem,
   xếp MỚI XEM NHẤT trước (localStorage `bamboove-da-xem-v2` giữ tối đa 8, mới nhất ở đầu).
   (Cột "Recently viewed" bên trái máy tính vẫn giữ mức 4 thẻ cho gọn — dùng TOI_DA_RV riêng.) */
const TOI_DA_GOIY_RV = 8;

/** KÉO NGANG bằng CHUỘT cho carousel gợi ý (điện thoại: trình duyệt tự lo phần swipe).
 *  Anh chốt: "kéo sang xem được hết" — KHÔNG thanh kéo, KHÔNG mũi tên. */
function batKeoNgang() {
  const khung = document.querySelector('#cart-drawer [data-bb-goiy-ds]');
  if (!khung || khung.dataset.bbKeo === '1') return;
  khung.dataset.bbKeo = '1';

  let dangKeo = false;
  let x0 = 0;
  let cuon0 = 0;
  let daKeo = 0;

  khung.addEventListener('pointerdown', (ev) => {
    if (ev.pointerType === 'touch') return; /* cảm ứng: để trình duyệt tự cuộn */
    dangKeo = true;
    daKeo = 0;
    x0 = ev.clientX;
    cuon0 = khung.scrollLeft;
    /* 🔴 76 m (17/10/2026) — KHÔNG `setPointerCapture` (bài học phiên 76d: capture “NUỐT” cú bấm —
       đã sửa cho thẻ NGOÀI, chỗ này còn sót): máy tính bấm “+ Add” ở “Add a little extra…” thì
       pointerup/click bị đổi mục tiêu về chính khung kéo ⇒ handler không thấy nút ⇒ KHÔNG mở popup
       (điện thoại không dính vì `pointerType === 'touch'` thoát sớm — đúng như anh Trung thấy).
       Nay theo dõi kéo bằng listener trên `window` — không cần capture. */
  });

  window.addEventListener('pointermove', (ev) => {
    if (!dangKeo) return;
    const d = ev.clientX - x0;
    if (Math.abs(d) > daKeo) daKeo = Math.abs(d);
    khung.scrollLeft = cuon0 - d;
  });

  const nhaChuot = () => {
    dangKeo = false;
  };
  window.addEventListener('pointerup', nhaChuot);
  window.addEventListener('pointercancel', nhaChuot);
  khung.addEventListener('pointerleave', nhaChuot);

  /* Kéo xong mà nhả chuột trên 1 thẻ ⇒ KHÔNG mở trang sản phẩm (khách chỉ muốn kéo) */
  khung.addEventListener(
    'click',
    (ev) => {
      if (daKeo > 6) {
        ev.preventDefault();
        ev.stopPropagation();
        daKeo = 0;
      }
    },
    true
  );
}

/** Vẽ “Recently viewed” vào khung gợi ý (lọc món đang có trong giỏ, tối đa 4 thẻ). */
function veGoiYTheoRV() {
  const khoi = document.querySelector('#cart-drawer [data-bb-goiy]');
  const ds = document.querySelector('#cart-drawer [data-bb-goiy-ds]');
  if (!khoi || !ds) return;

  const dangCo = new Set(
    Array.from(document.querySelectorAll('#cart-drawer .bb-gio__mten[href*="/products/"]')).map(
      (a) => String(a.getAttribute('href')).split('/products/')[1]?.split('?')[0] || ''
    )
  );
  const dsHien = docRV()
    .filter((x) => x && x.handle && !dangCo.has(x.handle) && x.handle !== handleDangXem())
    .slice(0, TOI_DA_GOIY_RV); /* 75b: hiện HẾT sản phẩm đã xem (mới nhất trước) · 75m: bỏ món ĐANG mở */

  if (!dsHien.length) {
    /* 16/10/2026 (phiên 75 n) — TRƯỚC ĐÂY: rỗng ⇒ ẩn cả khối ⇒ khách thấy “trống trơn” như lỗi.
       Nay: hiện 1 dòng báo cho biết vì sao chưa có gì. */
    ds.innerHTML =
      '<li class="bb-gio__goiy-rong">You haven’t viewed any other products yet.</li>';
    khoi.hidden = false;
    return;
  }

  ds.innerHTML = dsHien
    .map(
      (x) =>
        /* 16/10/2026 (phiên 75 o) — ANH CHỐT LẠI: dùng THẺ KIỂU ĐIỆN THOẠI (gói nhỏ nằm ngang)
           với nút “+ Add” Ở GÓC PHẢI; bấm nút ⇒ hiện BẢNG SIZE ⇒ bấm size = thêm vào giỏ.
           (Bản 75 n làm thẻ product card dọc — anh không muốn, đã quay lại kiểu này.) */
        `<li class="bb-gio__goiy-o">` +
        `<a href="${x.url || '/products/' + x.handle}">` +
        `${x.image ? `<img class="bb-gio__goiy-anh" src="${x.image}" alt="${x.title || x.handle || ''}" width="56" height="56" loading="eager">` : ''}` +
        `<span class="bb-gio__goiy-tin"><span class="bb-gio__goiy-ten-o">${x.title || x.handle}</span>` +
        `<span class="bb-gio__goiy-gia" data-bb-rv-gia="${x.handle}">${x.price || ''}</span></span></a>` +
        /* 16/10/2026 (phiên 75 s) — ANH CHỐT LẠI:
           · ĐIỆN THOẠI: BỎ nút hình giỏ, đổi chữ “View” → **“Add”**, bấm = MỞ POPUP thêm nhanh.
           · MÁY TÍNH: giữ nút GIỎ ở góc (rê chuột mới hiện) ⇒ cũng mở POPUP. */
        `<button type="button" class="bb-gio__add-chu" data-bb-qa="${x.handle}">Add</button>` +
        `<button type="button" class="bb-gio__qa" data-bb-qa="${x.handle}" aria-label="Add to bag">` +
        `<svg viewBox="0 0 24 24" aria-hidden="true">` +
        `<path d="M6 6h15l-1.6 9.2H7.3L6 6Z"/><path d="M6 6 5 3H2.8"/>` +
        `<circle cx="9.2" cy="19.4" r="1.4"/><circle cx="17.6" cy="19.4" r="1.4"/></svg>` +
        `</button>` +
        `</li>`
    )
    .join('');
  khoi.hidden = false;

  /* lấy GIÁ MỚI cho từng thẻ (giống cột trái)
     ⚠️ 16/10/2026: PHẢI chọn theo `[data-bb-rv-gia]` — trước đó tôi lấy `previousElementSibling`
     của nút “+ Add” thì trúng thẻ <a> (vì <a> bọc ảnh + tên + giá) ⇒ **xoá mất ảnh + tên**,
     thẻ chỉ còn mỗi giá (đo được: thẻ 170×58, không có ảnh). */
  dsHien.forEach((x) => {
    fetch(`/products/${encodeURIComponent(x.handle)}.js`)
      .then((r) => r.json())
      .then((sp) => {
        if (!sp || !sp.price) return;
        const theGia = ds.querySelector(`[data-bb-rv-gia="${x.handle}"]`);
        if (theGia) theGia.textContent = '$' + (sp.price / 100).toFixed(2);
      })
      .catch(() => {});
  });

  /* 76 m — nạp trước quick-add cho 3 món đầu của tab “Recently viewed” (như “Add a little extra”) */
  dsHien.slice(0, 3).forEach((x, i) => {
    setTimeout(() => napTruocQuickAdd(x.handle), 350 + i * 350);
  });
}

/** Đổi tab: cập nhật nút + vẽ đúng danh sách. */
function chonTabGoiY(ten) {
  tabGoiY = ten === 'rv' ? 'rv' : 'goiy';

  /* (16/10/2026 · phiên 75 p) — ĐÃ BỎ kiểu “Recently viewed = 1 cột”: anh chốt lại
     “recent view trên điện thoại phải làm kiểu kéo ngang chứ, như cái add little extra ý”
     ⇒ 2 tab dùng CHUNG carousel kéo ngang (không cần class riêng nữa). */
  document.querySelectorAll('#cart-drawer [data-bb-tab]').forEach((b) => {
    const chon = b.dataset.bbTab === tabGoiY;
    b.classList.toggle('is-active', chon);
    b.setAttribute('aria-selected', chon ? 'true' : 'false');
  });
  if (tabGoiY === 'rv') veGoiYTheoRV();
  else taiGoiY(true);

  /* 75b: mỗi tab là 1 carousel riêng ⇒ về đầu danh sách + gắn kéo ngang (gọi lại an toàn) */
  const khung = document.querySelector('#cart-drawer [data-bb-goiy-ds]');
  if (khung) khung.scrollLeft = 0;
  batKeoNgang();
}

document.addEventListener('click', (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-tab]') : null;
  if (!nut) return;
  ev.preventDefault();
  chonTabGoiY(nut.dataset.bbTab);
});

/* Giỏ vẽ lại (thêm/xoá món) hoặc mở giỏ ⇒ vẽ lại ĐÚNG tab đang chọn theo dữ liệu MỚI
   (chờ ruột giỏ vẽ xong mới lọc được “món đang có trong giỏ”). */
for (const ten of SU_KIEN_GIO) {
  document.addEventListener(ten, () => setTimeout(() => chonTabGoiY(tabGoiY), 700));
}
document.addEventListener('theme-drawer:open', () => {
  /* Anh chốt (phiên 75 c): “mở ra thì recently viewed hiện LUÔN — không đợi load / hiệu ứng gì”.
     ⇒ vẽ NGAY bằng dữ liệu đã lưu trong máy khách (localStorage), KHÔNG chờ mạng;
     sau 600ms vẽ lại một lần để lọc đúng “món đang có trong giỏ” (khi ruột giỏ vẽ xong). */
  chonTabGoiY(tabGoiY);
  setTimeout(() => chonTabGoiY(tabGoiY), 600);
});

/* ============================================================================
   16/10/2026 (phiên 75 p) — DẢI KÉO CHỈ HIỆN KHI ĐANG KÉO (mỏng 4px · màu brand)
   Anh Trung: “chỉ khi nào kéo nó sang, hoặc lên xuống … thì mới hiện cái dải đó,
   nhưng làm nó thật mỏng và nhỏ thôi, đúng với brand của mình”.
   · Nghe `scroll` ở pha CAPTURE (sự kiện scroll KHÔNG bubble) ⇒ bắt được MỌI vùng cuộn trong giỏ:
     vùng cuộn chính · carousel gợi ý/Recently viewed · danh sách cột trái máy tính.
   · Gắn class `.bb-dang-cuon` (CSS mới cho thumb hiện) ⇒ tự gỡ sau 0,9 giây.
   LÙI BÀI: xoá khối này + mọi luật `.bb-dang-cuon` trong assets/bamboove-cart-tabs.css
   (khi đó scrollbar về mặc định của trình duyệt).
   ============================================================================ */
const VUNG_CUON =
  '#cart-drawer .bb-gio__cuon, #cart-drawer .bb-gio__goiy-ds, #cart-drawer .bb-gio__rv-ds, #cart-drawer .bb-gio__cot-rv-ds';

/* ============================================================================
   17/10/2026 (phiên 76 g) — NỐI SANG **QUICK-ADD GỐC CỦA HORIZON** (thay popup `.bb-qa` tự chế)
   Anh Trung: “hay lấy nguyên cái pop up của horizon đi… của mình nhìn xấu quá”.
   Luồng MỚI: mọi nút Add (thẻ “Add a little extra” · tab “Recently viewed” · cột trái máy tính ·
   nút “Add”/giỏ trên thẻ gợi ý) ⇒ mở MODAL quick-add của Horizon (`assets/quick-add.js`):
   ảnh lớn · tên + giá · size chip · số lượng −1+ · Add to cart · Shop Pay · More payment options.
   · Khối nguồn ẨN nằm cuối `snippets/cart-drawer.liquid` (`<product-card data-bb-qa-nguon>` +
     `<a ref="productCardLink">` + `<quick-add-component>`). Mỗi lượt bấm: gán `href` +
     `data-product-title` rồi gọi `handleClick()` — Horizon tự fetch + dựng + mở modal.
   · Đuôi `?view=quickadd` trỏ sang `templates/product.quickadd.json` (bản GỐC Horizon, sinh bằng
     `_TOOLS/_p76g-tao-template-quickadd.py`) — vì PDP của mình là section riêng `bamboove-pdp`,
     KHÔNG có khối `[data-product-grid-content]` mà quick-add cần bóc.
   · Vẫn GIỮ `themVaoGioThat()` + bảng chọn cỡ cũ (`moBangSize`) làm ĐƯỜNG DỰ PHÒNG.
   🔁 LÙI BÀI: khôi phục khối popup ở commit `7139a36` (moQA/dongQA/veAnhQA + markup + CSS).
   ============================================================================ */
function moQuickAddHorizon(handle, ten) {
  const the = document.querySelector('[data-bb-qa-nguon]');
  const qa = the ? the.querySelector('quick-add-component') : null;
  const a = the ? the.querySelector('[ref="productCardLink"]') : null;
  if (!qa || !a || !handle) return false;

  /* URL riêng cho quick-add: `?view=quickadd` ⇒ máy chủ trả `templates/product.quickadd.json`
     (có `[data-product-grid-content]`) — trang PDP thường của Bamboove KHÔNG có khối này. */
  a.setAttribute('href', '/products/' + encodeURIComponent(handle) + '?view=quickadd');
  qa.dataset.productTitle = ten || '';

  const mo = async () => {
    /* 76 h — “BẤM LÀ MỞ NGAY”: mở khung modal + LỚP ĐANG TẢI trước; Horizon fetch xong thì lớp
       tải tự gỡ ⇒ nội dung hiện ra. (Đo trước khi sửa: lần mở đầu 1.840ms mới thấy modal.) */
    const dlg = document.getElementById('quick-add-dialog');
    const hop = dlg ? dlg.querySelector('dialog') : null;
    if (hop) hop.classList.add('bb-qa-dang-tai');
    try {
      if (dlg && hop && !hop.open && typeof dlg.showDialog === 'function') dlg.showDialog();
      await qa.handleClick(new Event('click'));
      if (hop) hop.classList.remove('bb-qa-dang-tai');
      return true;
    } catch {
      /* Mạng lỗi / fetch hỏng: gỡ lớp tải; khung vừa mở “trộm” thì đóng lại cho gọn. */
      if (hop) hop.classList.remove('bb-qa-dang-tai');
      if (dlg && hop && hop.open && typeof dlg.closeDialog === 'function') dlg.closeDialog();
      return false;
    }
  };

  if (typeof qa.handleClick === 'function') {
    mo();
    return true;
  }

  /* `quick-add.js` nạp “fetchpriority low” ⇒ lượt bấm QUÁ SỚM có thể chưa kịp nâng cấp element.
     Chờ định nghĩa xong rồi mở (KHÔNG rơi về bảng chọn cỡ — tránh 2 kiểu UI khác nhau). */
  if (window.customElements && customElements.whenDefined) {
    customElements
      .whenDefined('quick-add-component')
      .then(() => {
        if (typeof qa.handleClick === 'function') mo();
      })
      .catch(() => {});
    return true;
  }
  return false;
}

/* Cho các khối khác gọi ké (assets/bamboove-bestsellers.js: nút giỏ GÓC PHẢI TRÊN thẻ ở điện thoại —
   trang chủ · bộ sưu tập · tìm kiếm · you-may-also-like) — cùng mở đúng modal này. */
window.bambooveQuickAdd = { mo: moQuickAddHorizon };

/* ============================================================================
   76 h (17/10/2026) — NẠP TRƯỚC trang `?view=quickadd` khi khách chỉ MỚI HƯỚNG tới nút Add
   (rê chuột vào nút · chạm ngón tay xuống nút) ⇒ lúc bấm THẬT, trình duyệt lấy bản trong cache
   ⇒ modal mở nhanh hơn hẳn. Mỗi sản phẩm chỉ nạp 1 lần trong phiên.
   Đo trước/sau bằng `_TOOLS/_p76h3-dieu-tra-chip.py` (mở lần đầu 1.840ms; mở lại 47ms —
   nạp trước giúp lượt ĐẦU cũng nhanh như lượt sau).
   ============================================================================ */
const daNapTruocQA = new Set();

function napTruocQuickAdd(handle) {
  if (!handle || daNapTruocQA.has(handle)) return;
  daNapTruocQA.add(handle);
  try {
    fetch('/products/' + encodeURIComponent(handle) + '?view=quickadd', { priority: 'low' }).catch(() => {});
  } catch {
    /* trình duyệt cũ: bỏ qua */
  }
}

/* Lấy handle từ BẤT KỲ nút Add nào (thẻ gợi ý trong giỏ · nút “Add”/giỏ trên thẻ · thẻ trang chủ) */
function handleTuNutQA(nut) {
  if (!nut) return '';
  if (nut.dataset.bbRvThem) return nut.dataset.bbRvThem;
  if (nut.dataset.bbQa) return nut.dataset.bbQa;
  if (nut.dataset.bbGoiyThem) {
    const sp = timSanPhamTheoBienThe(nut.dataset.bbGoiyThem);
    return sp && sp.handle ? sp.handle : '';
  }
  const card = nut.closest('.product-card');
  return card ? card.getAttribute('data-product-handle') || '' : '';
}

const NUT_ADD_QA = '[data-bb-goiy-them], [data-bb-rv-them], [data-bb-qa], .card-quickadd button';

document.addEventListener(
  'pointerover',
  (ev) => {
    const nut = ev.target instanceof Element ? ev.target.closest(NUT_ADD_QA) : null;
    if (nut) napTruocQuickAdd(handleTuNutQA(nut));
  },
  true
);

document.addEventListener(
  'pointerdown',
  (ev) => {
    const nut = ev.target instanceof Element ? ev.target.closest(NUT_ADD_QA) : null;
    if (nut) napTruocQuickAdd(handleTuNutQA(nut));
  },
  true
);

/* ============================================================================
   76 k (17/10/2026) — LUỒNG “MƯỢT” CHO NÚT “Add to cart” TRONG MODAL QUICK-ADD
   Anh Trung: *“bấm add to cart là có cái hiệu ứng máy bay bay vào giỏ… load xong thì hiện giỏ ra…
   không hiển thị đang load”* + *“hiển vào giỏ trước rồi chạy cái kia sau”*.
   Luồng mới — giỏ đang ĐÓNG:
     ① ĐÓNG modal NGAY (không chờ máy chủ, không hiện vòng xoay)
     ② modal đóng HẲN ⇒ ẢNH SẢN PHẨM BAY vào nút giỏ ở header (hiệu ứng P76c; phải đợi đóng vì
        modal nằm ở LỚP TRÊN CÙNG — mọi thứ khác đều bị nó che)
     ③ ĐÁNH DẤU “đang chờ kết quả” (`choKetQuaModalAdd`) — KHỐI SỰ KIỆN GIỎ (mục 76 k phía trên)
        sẽ lấy lại ruột giỏ + mở giỏ ĐÚNG LÚC máy chủ trả lời (không lấy sớm ⇒ không mở giỏ trống)
   Giỏ đang MỞ (thêm từ gợi ý ngay trong giỏ): chỉ đóng modal — ruột giỏ tự vẽ lại, KHÔNG bay
   (nút giỏ đang bị giỏ che — đúng kiểu Horizon).
   ⚠️ KHÔNG `preventDefault`: form của Horizon vẫn chạy y nguyên (mình chỉ “đi trước” phần hình).
   Form CHƯA hợp lệ (vd chưa chọn cỡ) ⇒ để Horizon tự nhắc — mình không “diễn” gì.
   ============================================================================ */
document.addEventListener(
  'click',
  (ev) => {
    const nut =
      ev.target instanceof Element ? ev.target.closest('#quick-add-modal-content button[name="add"]') : null;
    if (!nut || nut.disabled) return;

    /* Form chưa hợp lệ ⇒ Horizon lo (hiện nhắc chọn cỡ…) */
    const form = nut.closest('form');
    if (!form) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;

    /* (76 k) CHẶN form của Horizon — mình tự gửi đơn ở dưới (kèm `sections` để có LUÔN HTML giỏ mới) */
    ev.preventDefault();

    /* Đo ĐÚNG ô ảnh sản phẩm LÚC NÀY — modal đóng xong thì mọi ô đo về 0 (display:none) */
    const hinh = document.querySelector(
      '#quick-add-modal-content .product-information__media img, #quick-add-modal-content media-gallery img, #quick-add-modal-content img'
    );
    const anhBay = hinh ? hinh.currentSrc || hinh.src || '' : '';
    const rBay = hinh ? hinh.getBoundingClientRect() : null;

    const dlgQA = document.getElementById('quick-add-dialog');
    const hopQA = dlgQA ? dlgQA.querySelector('dialog') : null;
    const gioDlg = document.querySelector('#cart-drawer dialog');
    const gioDangMo = !!(gioDlg && gioDlg.open && gioDlg.getBoundingClientRect().width > 0);

    /* ① ĐÓNG MODAL NGAY — gỡ luôn lớp “đang tải” (nếu còn) cho khỏi nháy */
    if (hopQA) hopQA.classList.remove('bb-qa-dang-tai');
    if (dlgQA && hopQA && hopQA.open && typeof dlgQA.closeDialog === 'function') dlgQA.closeDialog();

    /* ② sau khi modal đóng hẳn ⇒ ẢNH SẢN PHẨM BAY vào nút giỏ ở header (modal ở LỚP TRÊN CÙNG) */
    let daChay = false;
    const sauKhiDong = () => {
      if (daChay) return;
      daChay = true;
      if (gioDangMo) return; /* giỏ đang mở: nút giỏ bị che — khỏi bay */
      if (rBay && rBay.width && window.bambooveBayGio) {
        window.bambooveBayGio({
          nguon: { getBoundingClientRect: () => rBay }, /* “nguồn giả”: giữ đúng ô đo lúc bấm */
          anh: anhBay,
          loai: 'quick',
        });
      }
    };

    if (hopQA && hopQA.open) {
      hopQA.addEventListener('close', sauKhiDong, { once: true });
      setTimeout(sauKhiDong, 700); /* lưới an toàn nếu `close` không phát */
    } else {
      sauKhiDong();
    }

    /* ③ TỰ GỬI ĐƠN — kèm `sections` ⇒ máy chủ trả LUÔN HTML giỏ mới trong CÙNG phản hồi
       ⇒ `thayRuot` vẽ xong món ⇒ mới mở giỏ (“load xong thì hiện giỏ ra”, không khoảng trống). */
    const fd = new FormData(form);
    fd.append('sections', 'cart-drawer-section');
    fd.append('sections_url', location.pathname);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
    })
      .then((r) => r.json())
      .then(async (tra) => {
        if (!tra || tra.status || !tra.id) {
          baoLoiThemHang();
          return;
        }
        const html = tra.sections && tra.sections['cart-drawer-section'];
        if (html) window.bambooveGio?.thayRuot?.(html);
        else window.bambooveGio?.veLai?.(); /* dự phòng: máy chủ không kèm sections */
        /* giỏ đang ĐÓNG ⇒ MỞ NGAY (không chờ gì thêm) — ruột đã vẽ xong ngay trên nên mở là thấy ĐÚNG món
           (đo `_p76k`: đặt sau lượt `/cart.js` thì giỏ mở trễ thêm ~680ms — thừa) */
        if (!gioDangMo && window.bambooveGio?.mo) window.bambooveGio.mo();
        try {
          const gioHang = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
          window.bambooveGio?.dem?.(gioHang); /* số trên bong bóng giỏ ở header */
        } catch {
          /* bong bóng sẽ tự cập nhật ở lượt vẽ sau */
        }
      })
      .catch(() => baoLoiThemHang());
  },
  true
);

/* bấm nút “Add” (chữ, điện thoại) / nút GIỎ (góc thẻ, máy tính) trên thẻ gợi ý
   ⇒ MỞ QUICK-ADD GỐC HORIZON (76 g — trước đây gọi popup `.bb-qa`) */
document.addEventListener('click', (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('#cart-drawer [data-bb-qa]') : null;
  if (!nut) return;
  ev.preventDefault();
  const card = nut.closest('.bb-gio__goiy-o');
  const oTen = card ? card.querySelector('.bb-gio__goiy-ten-o') : null;
  moQuickAddHorizon(nut.dataset.bbQa, oTen ? oTen.textContent.trim() : '');
});

document.addEventListener(
  'scroll',
  (ev) => {
    const el = ev.target;
    if (!(el instanceof Element) || !el.matches(VUNG_CUON)) return;
    el.classList.add('bb-dang-cuon');
    clearTimeout(el._bbHenCuon);
    el._bbHenCuon = setTimeout(() => el.classList.remove('bb-dang-cuon'), 900);
  },
  true
);

/* ============================================================================
   16/10/2026 (phiên 75 x) — NÚT NHẮC “KÉO XUỐNG XEM PHÍ” (anh Trung yêu cầu)
   · Cơ chế giống nút “lên đầu trang” của PDP nhưng NGƯỢC: khối phí (`.bb-gio__tom-tien`)
     bị che ⇒ HIỆN nút; đã thấy khối phí ⇒ ẨN nút.
   · Bấm nút ⇒ cuộn mượt xuống khối phí + nút tự ẩn ngay.
   ============================================================================ */
let bbDangNhay = 0; /* mốc thời gian: đang trong lúc “nhảy xuống” ⇒ KHÔNG cập nhật nút (tránh nhấp nháy) */

function capNhatNutNhay() {
  const nut = document.querySelector('[data-bb-nhay]');
  const khoi = document.querySelector('[data-bb-tom-tien]');
  const cuon = document.querySelector('#cart-drawer [data-bb-cuon]');
  if (!nut || !khoi || !cuon) return;

  /* đang nhảy xuống (1,2 giây đầu) ⇒ để yên, không bật nút lên lại giữa đường */
  if (performance.now() - bbDangNhay < 1200) return;

  /* giỏ rỗng / khối phí đang bị ẩn ⇒ không nhắc gì */
  if (khoi.hasAttribute('hidden') || khoi.offsetParent === null) {
    nut.hidden = true;
    return;
  }

  const rk = khoi.getBoundingClientRect();
  const rc = cuon.getBoundingClientRect();
  /* khối phí ĐÃ HIỆN (đáy khối không vượt quá mép dưới vùng cuộn quá 28px) ⇒ ẩn nút.
     Nới 28px vì mép dưới vùng cuộn bị chân giỏ che một phần (đo được: đáy khối 710 vs mép 692). */
  nut.hidden = rk.bottom <= rc.bottom + 28;
}

document.addEventListener('click', (ev) => {
  const nut = ev.target instanceof Element ? ev.target.closest('[data-bb-nhay]') : null;
  if (!nut) return;
  ev.preventDefault();
  const khoi = document.querySelector('[data-bb-tom-tien]');
  const cuon = document.querySelector('#cart-drawer [data-bb-cuon]');
  if (!khoi || !cuon) return;
  nut.hidden = true; /* bấm là BIẾN MẤT (anh chốt) */
  bbDangNhay = performance.now();
  /* khối phí là khối CUỐI vùng cuộn ⇒ cuộn tới ĐÁY cho chắc (đo được: cuộn tới đáy là thấy đủ) */
  cuon.scrollTo({ top: cuon.scrollHeight, behavior: 'smooth' });
  setTimeout(capNhatNutNhay, 1400);
});

/* cập nhật khi: cuộn vùng giỏ · mở giỏ · giỏ vẽ lại (thêm/xoá món) · đổi cỡ màn hình */
document.addEventListener(
  'scroll',
  (ev) => {
    const el = ev.target;
    if (el instanceof Element && el.matches('#cart-drawer [data-bb-cuon]')) capNhatNutNhay();
  },
  true
);

document.addEventListener('theme-drawer:open', () => setTimeout(capNhatNutNhay, 900));

SU_KIEN_GIO.forEach((ten) => {
  document.addEventListener(ten, () => setTimeout(capNhatNutNhay, 900));
});

document.addEventListener('cart:refresh', () => setTimeout(capNhatNutNhay, 900));
window.addEventListener('resize', () => setTimeout(capNhatNutNhay, 250));
setTimeout(capNhatNutNhay, 1500);
